import { RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType } from '../baseHelper';
import { InvitationStateAud } from '@api/models/invitation/InvitationStateAud';

type State = BaseType<InvitationStateAud | undefined>;

const initialState: State = {
  state: FetchState.None,
  data: undefined,
};

export const invitationStateAudSlice = baseSlice({
  name: 'invitationStateAud',
  initialState,
});

export const selectInvitationStateAudState = (state: RootState) => state.invitationStateAud.state;
export const selectInvitationStateAud = (state: RootState) => state.invitationStateAud.data;
export const invitationStateAudActions = invitationStateAudSlice.actions;
